import { Component, OnInit } from '@angular/core';
import { SpinnerService } from '../../core.index';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit {
  loading$!: Observable<boolean>;

  constructor(private spinner: SpinnerService) {}

  ngOnInit(): void {
    this.loading$ = this.spinner.loading$;
  }
}
